import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

import CheckListIcon from "../../../../../public/images/icons/check-list.svg";
import Banner from "../../../../../public/images/freebird/friends-at-gate.jpg";

const BackgroundBlur = styled.div`
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.65);
    z-index: 9999999;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ModalDiv = styled.div`
    background-color: white;
    padding: 45px 41px;
    display: flex;
    flex-direction: row;

    @media (max-width: 768px) {
        padding: 20px 25px;
        flex-direction: column-reverse;
        width: 350px;
    }

    & div:first-child {
        width: 400px;
        margin-right: 20px;

        & ul {
            list-style: none;
            padding-bottom: 23px;
        }

        @media (max-width: 768px) {
            margin-right: 0;
            margin-top: 20px;
        }
    }
`;

const Title = styled.h3`
    font-size: 44px;
    color: #264653;
    padding-bottom: 23px;

    @media (max-width: 768px) {
        font-size: 32px;
    }
`;

const Subtitle = styled.h4`
    font-size: 29px;
    color: #264653;
    padding-bottom: 23px;

    @media (max-width: 768px) {
        font-size: 21px;
        max-width: 260px;
    }
`;

const JoinButton = styled(Link)`
    padding: 14px 45px;
    background-color: #367580;
    border-color: #367580;
    font-size: 24px;
    font-weight: bold;
    margin: 0 5px 5px 5px;
    text-decoration: none;
`;

const HelpText = styled.h6`
    color: #313131;
    font-size: 1.2em;
    margin: 10px 0 0 5px;
    & a {
        color: #6d989a !important;
    }
`;

const ImageDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    & img {
        width: 100%;
    }
`;

const Popup = ({ popupContent }) => {
    const [pageData, setPageData] = useState(popupContent);

    const handleLogin = () => {
        window.open("/auth0/login", "_self");
    };

    return (
        <BackgroundBlur>
            <ModalDiv>
                <div>
                    <Title>{pageData[0]}</Title>
                    <Subtitle>{pageData[1]}</Subtitle>
                    <ul>
                        <li>
                            <img src={CheckListIcon} /> {pageData[2]}
                        </li>
                        <li>
                            <img src={CheckListIcon} /> {pageData[3]}
                        </li>
                        <li>
                            <img src={CheckListIcon} /> {pageData[4]}
                        </li>
                        <li>
                            <img src={CheckListIcon} /> {pageData[8]}
                        </li>
                    </ul>
                    <JoinButton className="btn btn-primary" to="/signup">
                        {pageData[5]}
                    </JoinButton>
                    <HelpText>
                        {pageData[6]}{" "}
                        <Link onClick={() => handleLogin()}>
                            {" "}
                            {pageData[7]}{" "}
                        </Link>
                    </HelpText>
                </div>
                <ImageDiv>
                    <img src={Banner} />
                </ImageDiv>
            </ModalDiv>
        </BackgroundBlur>
    );
};

export default Popup;
